import React from 'react';
import { useTranslation } from 'react-i18next';
import { BsWhatsapp } from "react-icons/bs";
import '../styles/whatsappButton.css';

const WhatsAppButton = () => {
  const { t } = useTranslation();

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(t('navbar.whatsapp_message'));
    window.open(`https://wa.me/573155381468?text=${message}`, '_blank');
  };

  return (
    <button
      className="whatsapp-floating-button pulse"
      onClick={handleWhatsAppClick}
      aria-label="Contactar por WhatsApp"
      title={t('whatsapp.title')}
    >
      <BsWhatsapp />
    </button>
  );
};

export default WhatsAppButton;
